module.exports = __webpack_public_path__ + "media/images/icons/SVG/018-f2cd1dd71fb54352b2ba17bba288074b.svg";